import {h, Fragment} from "preact"
import { useActions, useProductFilters, useAppState } from '@nosto/preact';
import { useState, useEffect } from 'preact/hooks';

export default ({ facet, value }) => {
    const { toggleProductFilter, updateSearch } = useActions();
    const { response: { products } } = useAppState()
    const { filters } = useProductFilters();


    return (
        <li class="ns-d-flex ns-align-items-center ns-font-3 ns-facet-container"
            onClick={(e) => {
                e.preventDefault();
                toggleProductFilter(
                    facet.field,
                    value.value,
                    !value.selected
                )
            }}
        >
            <span class={!value.selected ? "ns-facet-item" : "ns-facet-item selected"}>{value.value}</span>
            {value.selected && <span class="ns-count ns-d-inline-block ns-text-align-center"> ({value.count})</span>}
        </li>
    )
}
